<template>
  <div v-if="state.invitationIsLoad" class="container wrapper" :class="bgImageUrl ? 'background_shadow' : ''" :style="{ backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : '' }">
    <transition name="fade" mode="out-in">
      <CampaignConsent
        v-if="alreadyHasAccount || state.redirect === 'consent'"
        @setBackground="handleBG"
      />
      <LoginOrRegister
        v-else-if="!invitationIsPrivate && !state.redirect"
        @goToRegister="state.redirect = 'register'"
        @continue="state.redirect = 'consent'"
        @setBackground="handleBG"
      />
      <RegisterForm v-else  @setBackground="handleBG" />
    </transition>
  </div>
</template>

<script setup>
import { computed, reactive, ref } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import { useRouter, useRoute } from "vue-router";
import CampaignConsent from "./partials/CampaignConsent.vue";
import RegisterForm from "./partials/register/RegisterForm.vue";
import LoginOrRegister from "./partials/LoginOrRegister.vue";

const router = useRouter();
const route = useRoute();

const candidateStore = useCandidateStore();

if (candidateStore.auth_token_game) {
  candidateStore.getCandidate();
}

const invitationIsPrivate = computed(() => {
  return candidateStore.invitation.email;
});

const alreadyHasAccount = computed(() => {
  return candidateStore.invitation.already_has_account;
});

const state = reactive({
  redirect: null,
  invitationIsLoad: false,
});


const bgImageUrl = ref(null);


 function handleBG(image) {
  bgImageUrl.value = image;
}

if (route.query.invitation_id) {
  await candidateStore.getInvitation(route.query.invitation_id);

  if (!candidateStore.invitation.campaign) {
    //TODO Go new page campaign link no longer active
    router.push({ name: "game-login" });
  } else {
    state.invitationIsLoad = true;
  }
} else {
  router.push({ name: "game-login" });
}
</script>

<style>
.background_shadow {
  position: relative; /* Enable positioning context for pseudo-element */
}

.background_shadow::before {
  content: ""; /* Required to display the pseudo-element */
  position: absolute; /* Position it relative to the parent */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent shadow */
  z-index: 1; /* Place it above the background but below child elements */
  pointer-events: none; /* Allow interactions with content inside the div */
}

.background_shadow > * {
  position: relative; /* Ensure content is above the shadow */
  z-index: 2;
}
</style>